<template>
  <v-container fluid class="pa-6 mt-n6">
    <!-- Header -->
    <v-row align="center" justify="center">
      <v-col cols="12" md="auto">
        <div class="d-flex align-center justify-center">
          <v-avatar color="red lighten-1" size="48" class="mr-4">
            <v-icon color="white" size="28">mdi-note-remove</v-icon>
          </v-avatar>
          <div>
            <h1 class="text-h4 font-weight-bold grey--text text--darken-3 mb-0">
              Notas de Crédito
            </h1>
            <p class="text-caption grey--text text--darken-1 mb-0 mt-1">
              Gestión y control de notas de crédito
            </p>
          </div>
        </div>
      </v-col>
    </v-row>

    <!-- Filtros -->
    <v-row justify="center">
      <v-col cols="12">
        <search-header-po @dataFilters="changeBusiness($event)" />
      </v-col>
    </v-row>

    <!-- Tabla -->
    <v-card class="rounded-lg elevation-1 mt-3">
      <v-expand-transition>
        <v-row v-if="loading" justify="center">
          <v-col cols="12" md="10">
            <v-skeleton-loader
              type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"
            />
          </v-col>
        </v-row>
        <v-data-table
          v-else
          :search="search"
          :headers="headers"
          :items="invoices"
          class="elevation-0"
          :footer-props="{ 'items-per-page-options': [15, 30, 50, 100] }"
          :items-per-page="15"
        >
          <template v-slot:top>
            <v-toolbar class="elevation-0 rounded-t-lg" color="white">
              <v-text-field
                v-model="search"
                label="Buscar nota, factura, cliente..."
                prepend-inner-icon="mdi-magnify"
                hide-details
                outlined
                dense
                clearable
                class="mr-4"
                style="max-width: 340px"
              />
              <v-spacer />

              <v-dialog transition="slide-x-transition" v-model="dialog" fullscreen>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-if="lastFilters.location != 0 && hasFeature('ING-043')"
                    @click="editOrCopyStatus = false"
                    color="red lighten-1"
                    dark
                    depressed
                    class="mr-2 text-none"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon small left>mdi-plus</v-icon>
                    Nueva nota crédito
                  </v-btn>
                  <v-tooltip v-else bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon disabled v-bind="attrs" v-on="on">
                        <v-icon>mdi-plus-circle-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Selecciona una sucursal</span>
                  </v-tooltip>
                </template>
                <v-card style="background-color: #f4f5fa">
                  <v-container>
                    <v-row justify="center">
                      <v-col cols="12" md="12">
                        <invoice
                          v-if="dialog"
                          :type="3"
                          :type_invoice="2"
                          :editOrCopy="editedItem"
                          :itbis="itbis"
                          :credit_days="credit_days"
                          :ncfTypes="ncfTypes"
                          :withholdings="withholdings"
                          :boxes="boxes"
                          :accounts="accounts"
                          :itemsLocations="itemsLocations"
                          :invoice_categories="invoice_categories"
                          :itemsDepartments="itemsDepartments"
                          :editOrCopyStatus="editOrCopyStatus"
                          @close-dialog="clear()"
                          @save-note="save($event)"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                  <v-card-text>
                    <v-row />
                  </v-card-text>
                </v-card>
              </v-dialog>

              <v-menu bottom origin="center center" transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="success"
                    outlined
                    depressed
                    class="text-none"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon left>mdi-download</v-icon>
                    Exportar
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item @click="generate_excel_detail(1)">
                    <v-list-item-icon>
                      <v-icon color="success">mdi-file-excel-box</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Reporte resumido</v-list-item-title>
                  </v-list-item>
                  <v-list-item disabled>
                    <v-list-item-icon>
                      <v-icon color="grey">mdi-file-excel-box</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Reporte detallado</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-toolbar>
            <v-divider />
          </template>

          <!-- Nota -->
          <template v-slot:[`item.id`]="{ item }">
            <v-hover v-slot="{ hover }">
              <span
                @click="showNote(item.id, true)"
                class="font-weight-medium"
                :style="{
                  color: hover ? '#E53935' : '#1565C0',
                  cursor: 'pointer',
                  'text-decoration': hover ? 'underline' : 'none',
                  transition: 'color 0.15s',
                }"
              >
                <v-icon x-small :color="hover ? 'red darken-1' : 'primary'" class="mr-1" style="vertical-align: middle">mdi-open-in-new</v-icon>
                {{ item.invoice_note_number }}
              </span>
            </v-hover>
          </template>

          <!-- Factura -->
          <template v-slot:[`item.invoice_number`]="{ item }">
            <v-hover v-slot="{ hover }">
              <span
                @click="showInvoice(item.invoice_id, true)"
                class="font-weight-medium"
                :style="{
                  color: hover ? '#E53935' : '#1565C0',
                  cursor: 'pointer',
                  'text-decoration': hover ? 'underline' : 'none',
                  transition: 'color 0.15s',
                }"
              >
                <v-icon x-small :color="hover ? 'red darken-1' : 'primary'" class="mr-1" style="vertical-align: middle">mdi-open-in-new</v-icon>
                {{ item.invoice_number }}
              </span>
            </v-hover>
          </template>

          <!-- Total -->
          <template v-slot:[`item.total_amount`]="{ item }">
            <span class="font-weight-medium">
              {{ currencyFormat(item.total_amount) }}
              <span class="text-caption grey--text ml-1">{{ item.currency_code }}</span>
            </span>
          </template>

          <!-- Cliente -->
          <template v-slot:[`item.entity_name`]="{ item }">
            <v-hover v-slot="{ hover }">
              <span
                @click="viewEntity(item.entity_id)"
                :style="{
                  color: hover ? '#E53935' : '#424242',
                  cursor: 'pointer',
                  'text-decoration': hover ? 'underline' : 'none',
                  transition: 'color 0.15s',
                }"
              >{{ item.entity_name }}</span>
            </v-hover>
          </template>

          <!-- DGII -->
          <template v-slot:[`item.dgii_status`]="{ item }">
            <div v-if="item.note_ncf">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    small
                    v-bind="attrs"
                    v-on="on"
                    :color="item.dgii_status === 'ACEPTADO' ? 'primary' : 'grey'"
                    :dark="item.dgii_status === 'ACEPTADO'"
                    :outlined="item.dgii_status !== 'ACEPTADO'"
                    class="px-3 font-weight-bold"
                    :class="item.dgii_status === 'ACEPTADO' ? 'elevation-2' : ''"
                  >
                    <v-icon small left>
                      {{ item.dgii_status === 'ACEPTADO' ? 'mdi-shield-check' : 'mdi-shield-alert' }}
                    </v-icon>
                    {{ item.dgii_status === 'ACEPTADO' ? 'DGII ✓' : 'Sin Validar' }}
                  </v-chip>
                </template>
                <div class="pa-2">
                  <div class="d-flex align-center mb-2">
                    <v-icon
                      :color="item.dgii_status === 'ACEPTADO' ? 'success' : 'warning'"
                      class="mr-2"
                    >
                      {{ item.dgii_status === 'ACEPTADO' ? 'mdi-check-circle' : 'mdi-information' }}
                    </v-icon>
                    <span class="font-weight-bold">
                      {{ item.dgii_status === 'ACEPTADO' ? 'Nota Aprobada por DGII' : 'Sin Verificación DGII' }}
                    </span>
                  </div>
                  <v-divider class="my-2" />
                  <div class="text-caption">
                    <strong>NCF:</strong> {{ item.note_ncf }}<br />
                    <strong>Estado:</strong> {{ item.dgii_status || 'Pendiente' }}
                  </div>
                </div>
              </v-tooltip>
            </div>
            <v-chip v-else small outlined color="grey" class="px-2">
              <v-icon small left>mdi-minus</v-icon>
              N/A
            </v-chip>
          </template>

          <!-- Status -->
          <template v-slot:[`item.status`]="{ item }">
            <v-chip
              small
              :color="item.status ? 'success' : 'red lighten-1'"
              :dark="!item.status"
              :outlined="!!item.status"
              class="font-weight-medium"
            >
              <v-icon x-small left>{{ item.status ? 'mdi-check-circle' : 'mdi-close-circle' }}</v-icon>
              {{ item.status ? 'Activa' : 'Anulada' }}
            </v-chip>
          </template>

          <template v-slot:no-data>
            <div class="text-center py-12">
              <v-icon size="72" color="grey lighten-2">mdi-note-remove-outline</v-icon>
              <p class="text-h6 grey--text mt-4">No hay notas de crédito</p>
              <p class="text-body-2 grey--text">Aplica los filtros y busca registros</p>
            </div>
          </template>
        </v-data-table>
      </v-expand-transition>
    </v-card>
  </v-container>
</template>

<script>
import ExcelJS from "exceljs";
export default {
  data: () => ({
    search: "",
    lastFilters: {},
    loading: false,
    dialog: false,
    dialogDelete: false,
    documents: [],
    rncValid: false,
    ncfTypes: [],
    accounts: [],
    itbis: [],
    invoices: [],
    itemsLocations: [],
    headers: [
      { text: "Nota", align: "start", value: "id" },
      { text: "Factura", align: "start", value: "invoice_number" },
      { text: "Comprobante", value: "note_ncf" },
      { text: "DGII", value: "dgii_status", align: "center", width: "10%" },
      { text: "Unidad negocio", value: "business_unit_description" },
      { text: "Sucursal", value: "location_description" },
      { text: "Cliente", value: "entity_name" },
      { text: "Total", value: "total_amount", align: "end" },
      { text: "Status", value: "status", align: "center" },
    ],
    editOrCopyStatus: false,
    itemsDepartments: [],
    credit_days: [],
    invoice_categories: [],
    withholdings: [],
    boxes: [],
    editedIndex: -1,
    editedItem: [],
  }),

  computed: {
    totalAmount() {
      return this.invoices.reduce((sum, i) => sum + parseFloat(i.total_amount || 0), 0);
    },
  },

  watch: {},

  created() {
    this.initialize();
  },

  methods: {
    async getData(data) {
      this.lastFilters = data;
      this.loading = true;
      let filters = "where invoices.invoice_type_id in(2,3,5,8) and note_type='CREDIT' ";
      filters += data.business == null ? " " : ` AND BUSINESS_UNITS.ID in (${data.business}) `;
      filters += data.location == null || data.location == 0 ? "" : ` AND INVOICES.LOCATION_ID IN (${data.location})`;
      filters += data.department_id == null || data.department_id == 0 ? "" : ` AND DEPARTMENT_ID =${data.department_id}`;
      filters += ` AND EFFECTIVE_DATE::DATE BETWEEN '${data.dateStart}' and '${data.dateEnd}' `;

      const resultInvoices = await this.api_Post("income/note_list", { filters });
      this.invoices = await resultInvoices.json();
      this.loading = false;
    },

    clear() {
      this.editedItem = null;
      this.dialog = false;
    },

    async initialize() {
      const result = await Promise.all([
        this.api_Get("accounting/taxes"),
        this.api_Get("accounting/accountsUsable"),
        this.api_Get("humanResource/locations"),
        this.api_Get("income/boxes"),
        this.api_Get("accounting/withholdings"),
        this.api_Get("income/invoice_categories"),
        this.api_Get("accounting/nfc_types"),
        this.api_Get("accounting/credit_days"),
        this.g_departments(),
      ]);

      this.itbis = await result[0].json();

      for (let item of await result[1].json()) {
        this.accounts.push({
          text: item.code + " - " + item.name,
          value: item.id,
          id: item.id,
          dgii_category_id: item.dgii_category_id,
        });
      }
      for (let item of await result[2].json()) {
        for (let item2 of this.$store.state.auth.locations) {
          if (item2.id == item.id) {
            this.itemsLocations.push({
              value: item.id,
              text: item.desc_loc_long,
              id: item.id,
              bus_id: item.bus_id,
              desc_bus_short: item.desc_bus_short,
              desc_bus_long: item.desc_bus_long,
              desc_loc_short: item.desc_loc_short,
              desc_loc_long: item.desc_loc_long,
              city_id: item.city_id,
              city_description: item.city_description,
              location_adress: item.location_adress,
              status_id: item.status_id,
              catalogue_id: item.catalogue_id,
              catalogue_name: item.catalogue_name,
              rnl: item.rnl,
              representative_name: item.representative_name,
              sta_description: item.sta_description,
              employee_representative_id: item.employee_representative_id,
            });
          }
        }
      }
      this.boxes = await result[3].json();
      this.withholdings = await result[4].json();
      this.invoice_categories = await result[5].json();
      this.ncfTypes = await result[6].json();
      this.ncfTypes.unshift({ id: 0, name: "SIN COMPROBANTE" });
      this.credit_days = await result[7].json();
      this.itemsDepartments = await result[8];
    },

    changeBusiness(data) {
      if (data.business == 0) {
        this.getData({
          business: this.$store.state.auth.user.acess_business_unit_finance,
          location: null,
          dateStart: data.dateStart,
          dateEnd: data.dateEnd,
        });
      } else {
        this.getData(data);
      }
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save(data) {
      this.loadingSave = true;
      this.getData(this.lastFilters);
      this.showNote(data[0].id, true);
      this.dialog = false;
      this.loadingSave = false;
    },

    async generate_excel_detail() {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Notas de Crédito");
      worksheet.columns = [
        { header: "UNIDAD DE NEGOCIO", key: "business_unit_description", width: 30 },
        { header: "CODIGO NOTA INTERNO", key: "invoice_note_number", width: 25 },
        { header: "CODIGO FACTURA ORIGINAL", key: "invoice_number", width: 25 },
        { header: "FECHA DE CREACIÓN", key: "created_date", width: 20 },
        { header: "FECHA EFECTIVA", key: "effective_date", width: 20 },
        { header: "FECHA CONTABLE", key: "account_date", width: 20 },
        { header: "CLIENTE", key: "entity_name", width: 40 },
        { header: "RAZÓN", key: "reason", width: 15 },
        { header: "MONEDA", key: "currency_code", width: 15 },
        { header: "MONTO TOTAL", key: "total_amount", width: 20 },
        { header: "SUBTOTAL", key: "subtotal_amount", width: 20 },
        { header: "ESTADO", key: "status", width: 15 },
        { header: "CONTABILIZADO", key: "recorded", width: 20 },
        { header: "REGISTRADO POR", key: "user", width: 25 },
      ];

      this.invoices.forEach((item) => {
        worksheet.addRow({
          business_unit_description: item.business_unit_description,
          invoice_note_number: item.invoice_note_number,
          invoice_number: item.invoice_number,
          created_date: item.created_date,
          effective_date: item.effective_date,
          account_date: item.account_date,
          entity_name: item.entity_name,
          reason: item.reason,
          currency_code: item.currency_code,
          total_amount: parseFloat(item.total_amount),
          subtotal_amount: parseFloat(item.subtotal_amount),
          status: item.status ? "Activa" : "Inactiva",
          recorded: item.recorded ? "Contabilizada" : "Sin Contabilizar",
          user: item.user,
        });
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: "application/octet-stream" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "Notas_de_Credito.xlsx";
      link.click();
    },
  },
};
</script>

<style scoped></style>
